module.exports = __webpack_public_path__ + "f95f204d9217db4a3ba2d6eda5717e07.png";